import { safeGet, safeSet } from './local-storage.js';

// One-time nudge pointing at the hamburger menu so people notice the theme
// switcher. Shown at most once ever (marked seen as soon as it's shown), and
// dismissed early the first time the menu is actually opened.
const MENU_HINT_STORAGE_KEY = 'halveren-menu-hint-seen';

function hasSeenMenuHint() {
    return !!safeGet(MENU_HINT_STORAGE_KEY);
}

function markMenuHintSeen() {
    safeSet(MENU_HINT_STORAGE_KEY, '1');
}

export function dismissMenuHint() {
    const hint = document.getElementById('menuHint');
    if (hint) hint.classList.remove('visible');
}

export function maybeShowMenuHint() {
    if (hasSeenMenuHint()) return;
    const hint = document.getElementById('menuHint');
    if (!hint) return;
    markMenuHintSeen();
    setTimeout(() => hint.classList.add('visible'), 500);
    setTimeout(() => dismissMenuHint(), 6500);
}

export function toggleMenu() {
    const menu = document.getElementById('sideMenu');
    const overlay = document.getElementById('menuOverlay');

    if (menu.classList.contains('active')) {
        closeMenu();
    } else {
        menu.classList.add('active');
        overlay.style.display = 'block';
        // Small delay to allow display change before opacity transition
        setTimeout(() => overlay.classList.add('active'), 10);
        dismissMenuHint();
        markMenuHintSeen();
    }
}

export function closeMenu() {
    const menu = document.getElementById('sideMenu');
    const overlay = document.getElementById('menuOverlay');

    menu.classList.remove('active');
    overlay.classList.remove('active');
    // Wait for transition to complete before hiding
    setTimeout(() => overlay.style.display = 'none', 300);
}
